import { useMemo, useCallback } from 'react';
import { usePeriodPickerTranslations } from './usePriodPickerTranslations';
import { useTranslation } from 'react-i18next';
import { IDropdownOption } from '@fluentui/react';

export const useApproverTranslations = () => {
    const { t } = useTranslation('approval');
    const stringsDatePicker = usePeriodPickerTranslations();
    const urpStateOptions: IDropdownOption[] = useMemo(
        () => [
            { key: 'selectalloption', text: t('filter.option.state.all') },
            { key: 'Open', text: t('filter.option.state.open') },
            { key: 'Submitted', text: t('filter.option.state.submitted') },
            { key: 'Rejected', text: t('filter.option.state.rejected') },
            { key: 'Approved', text: t('filter.option.state.approved') },
            { key: 'not created', text: t('filter.option.state.notcreated') },
        ],
        [t],
    );

    const getTranslatedPeriod = useCallback(
        (date: Date) => {
            const dayOfWeek = t(`common:mediumDays.${date.getDay()}`);
            const month = t(`common:shortMonths.${date.getMonth()}`);
            const day = date.getDate();
            const year = date.getFullYear();

            return `${dayOfWeek} ${month} ${day} ${year}`;
        },
        [t],
    );

    return { stringsDatePicker, urpStateOptions, getTranslatedPeriod };
};
